import { compose, withHandlers, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { withLocalization } from 'hocs/localization'
import { getSubscriptionPlans } from 'redux-app/selectors/subscription'
import { plans } from 'redux-app/modules/subscriptions'
import { getUserActivePlanId } from 'redux-app/selectors/user'
import { getNormalizedPlan } from './utils'
import ComparePlans from './ComparePlans'

export default compose(
  withLocalization('comparePlans'),
  connect(
    (state) => {

      const subscriptionPlans = getSubscriptionPlans(state).sort((a, b) => {
        if (a.weight === b.weight) {
          return !!a.activationFee ? 1 : -1
        }

        return a.weight > b.weight ? 1 : -1
      })

      subscriptionPlans.forEach(plan => {
        if (typeof plan['visible'] == 'undefined') {
          plan['visible'] = false;
        }
      })

      const groupByCategory = subscriptionPlans.reduce((group, plan) => {
        group[plan.weight] = group[plan.weight] ?? []
        group[plan.weight].push(plan)
        return group
      }, {})

      for (const item in groupByCategory) {
        if (groupByCategory[item].length == 1) {
          groupByCategory[item][0].visible = true
        }
        else if (groupByCategory[item][0].visible == false && groupByCategory[item][1].visible == false) {
          groupByCategory[item][0].visible = true
        }
      }

      const normalizedPlans = subscriptionPlans.map(plan => getNormalizedPlan(plan))
      const benefits = normalizedPlans.map(({ benefits }) => benefits)
      const features = normalizedPlans.map(({ features }) => features)

      for (const index in subscriptionPlans) {
        benefits[index]['visible'] = subscriptionPlans[index].visible
        benefits[index]['weight'] = subscriptionPlans[index].weight
        features[index]['visible'] = subscriptionPlans[index].visible
        features[index]['weight'] = subscriptionPlans[index].weight
      }

      return {
        subscriptionPlans,
        groupedPlans: groupByCategory,
        benefits,
        features,
        selectedPlanId: getUserActivePlanId(state),
      }
    },
    {
      plans,
    },
  ),
  withHandlers({
    onUpdatePlans: ({
      plans,
    }) => updatedPlans => {
      plans(updatedPlans)
    },
  }),
)(ComparePlans)
